import { atom } from 'recoil'
import { IProjectStage } from './projectTypes.types'

interface IProjectStagesAtom {
  items: IProjectStage[]
}

const projectStagesAtom = atom<IProjectStagesAtom>({
  key: 'project-stages',
  default: { items: [] },
})
export default projectStagesAtom
